<template>
	<div>
		<partners-map
			v-if="type === 'map'"
			v-bind="{ ...$attrs }"
			:partners="displayablePartners"
		/>
		<partners-list
			v-if="type === 'list'"
			v-bind="{ ...$attrs }"
			:partners="displayablePartners"
			:columns="columns"
			:show-image="showImagesInListType"
		/>
	</div>
</template>

<script>
import { VUEX_BUYOUT } from '../../../store/buyout';
import { mapActions, mapGetters } from 'vuex';
import { ACTION_TYPES } from "../../../store/buyout/_action-types";
import {GETTER_TYPES} from "../../../store/buyout/_getter-types";

export default {
	name: 'Partners',
	props: {
		type: {
			type: String,
			default: 'list',
			validator: val => ['list', 'map'].includes(val)
		},
		onlyMain: {
			type: Boolean,
			default: false
		},
		columns: {
			type: Number,
			default: 2
		},
		showImagesInListType:{
			type: Boolean,
			default: true
		}
	},
	async created() {
		if (!this[GETTER_TYPES.PARTNERS].length) await this[ACTION_TYPES.LOAD_PARTNERS]();
	},
	computed: {
		...mapGetters(VUEX_BUYOUT.NAMESPACE, [
			GETTER_TYPES.PARTNERS
		]),
		displayablePartners() {
			if (!this.onlyMain) return this[GETTER_TYPES.PARTNERS].filter(partner => partner.display_only_in_select_box === false);

			return this[GETTER_TYPES.PARTNERS].filter(partner => partner.is_main === this.onlyMain);
		}
	},
	methods: {
		...mapActions(VUEX_BUYOUT.NAMESPACE, [
			ACTION_TYPES.LOAD_PARTNERS
		]),
	},
	components: {
		PartnersList: () => import('./List'),
		PartnersMap: () => import('./Map')
	}
}
</script>
